import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import React, { useContext, useState } from "react";
import { Redirect } from "react-router";
import { useUserDetails } from "@sdk/react";
import { Offline, OfflinePlaceholder, Online, OverlayContext } from "..";
import CheckoutAsGuest from "./CheckoutAsGuest";
import ResetPasswordForm from "./ResetPasswordForm";
import SignInForm from "./SignInForm";

var CheckoutLogin = function CheckoutLogin() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      resetPassword = _useState2[0],
      setResetPassword = _useState2[1];

  var overlay = useContext(OverlayContext);

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  if (user) {
    return React.createElement(Redirect, {
      to: "/checkout/"
    });
  }

  return React.createElement("div", {
    className: "container"
  }, React.createElement(Online, null, React.createElement("div", {
    className: "checkout-login"
  }, React.createElement(CheckoutAsGuest, {
    overlay: overlay,
    checkoutUrl: "/checkout/"
  }), React.createElement("div", {
    className: "checkout-login__user"
  }, resetPassword ? React.createElement(ResetPasswordForm, {
    onClick: function onClick() {
      setResetPassword(false);
    }
  }) : React.createElement(SignInForm, {
    onClick: function onClick() {
      setResetPassword(true);
    }
  })))), React.createElement(Offline, null, React.createElement(OfflinePlaceholder, null)));
};

export default CheckoutLogin;